import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  getAllNipApplications,
  getSingleNipApplication,
} from "../../../redux/Actions/NipOnboardingActions";
import NipWrapper2 from "../../Nip/NipWrapper2";
import Storage from "../../../utils/storage";
import Spinner from "react-spinner-material";
import { mapStateToProps } from "./Nip-Doc-Upload/mapStateToProps";
import { getRequiredDocs } from "../../../redux/Actions/GetDocsActions";
import NoApplication from "./IntegrationHome/NoApplication";

const IntegrationHome = (props) => {
  const {
    isGetting,
    getSuccess,
    getApplications,
    managerId,
    getRequiredDocs,
    docs,
  } = props;

  useEffect(
    () => {
      getApplications();
    },
    // eslint-disable-next-line
    [getApplications]
  );

  useEffect(
    () => {
      if (getSuccess) {
        const type = "nip";
        getRequiredDocs(type);
      }
    },
    // eslint-disable-next-line
    [getSuccess]
  );

  const [state, setState] = useState({
    kit: true,
    selectType: false,
    docUpload: false,
    permitForm: false,
    shareKeys: false,
    runTest: false,
  });

  const selectType = selectTypeFunc(setState);
  const docUpload = docUploadFunc(setState);
  const ipPermitForm = ipPermitFormFunc(setState);
  const shareKeys = shareKeysFunc(setState);
  const runTests = runTestsFunc(setState);
  const kitDownload = Storage.get("kit-download-single");
  const selectIntType = Storage.get("select-type-single");
  const kitDownloadStatus = (trail) =>
    trail ? trail.downloaded_kit : kitDownload;
  const selectIntTypeStatus = (trail) =>
    trail ? trail.selected_integration_type : selectIntType;
  const uploadStartStatus = Storage.get("upload-start-single");
  const uploadFinishStatus = (trail) =>
    !trail ? false : trail.document_upload;
  const ipFormStatus = (trail) => trail && trail.ip_form_submission;
  const publicKeyStatus = (trail) => trail && trail.shared_public_key;
  const runTestStatus = (trail) => trail && trail.run_test;
  const scheduleMigrationStatus = (trail) => trail && trail.schedule_migration;
  const docApproval = (trail) => trail && trail.nip_document_approval;
  const requestManager = (trail) => trail && trail.network_manager_request;
  const ipPermitApproval = (trail) => trail && trail.ip_permit_approval;
  const testApproval = (trail) => trail && trail.test_approval;
  const migrationApproval = (trail) => trail && trail.migration_approval;
  const docApproved = Storage.get("docApproved");

  return (
    <NipWrapper2 currentRoute="/nip/integration/onboarding">
      {isGetting ? (
        <div className="center-spinner2">
          <Spinner
            size={120}
            color={"#047558"}
            spinnerwidth={5}
            visible={true}
          />
        </div>
      ) : getSuccess ? (
        <NoApplication
          state={state}
          selectType={selectType}
          docApproved={docApproved}
          ipPermitForm={ipPermitForm}
          docUpload={docUpload}
          kitDownloadStatus={kitDownloadStatus}
          selectIntTypeStatus={selectIntTypeStatus}
          uploadStartStatus={uploadStartStatus}
          uploadFinishStatus={uploadFinishStatus}
          ipFormStatus={ipFormStatus}
          publicKeyStatus={publicKeyStatus}
          runTestStatus={runTestStatus}
          scheduleMigrationStatus={scheduleMigrationStatus}
          docApproval={docApproval}
          requestManager={requestManager}
          ipPermitApproval={ipPermitApproval}
          testApproval={testApproval}
          migrationApproval={migrationApproval}
          docs={docs}
          getApplications={getApplications}
          shareKeys={shareKeys}
          managerId={managerId}
          runTests={runTests}
        />
      ) : (
        <div className="nip-error">
          <p>Error fetching trail</p>
        </div>
      )}
    </NipWrapper2>
  );
};

IntegrationHome.propTypes = {
  applications: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  docs: PropTypes.any,
  getApplication: PropTypes.func,
  getApplications: PropTypes.func,
  getRequiredDocs: PropTypes.func,
  getSuccess: PropTypes.any,
  isGetting: PropTypes.any,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.any,
    }),
  }),
  managerId: PropTypes.any,
};

const mapDispatchToProps = (dispatch) => ({
  getApplication: (id) => dispatch(getSingleNipApplication(id)),
  getApplications: () => dispatch(getAllNipApplications()),
  getRequiredDocs: (type) => dispatch(getRequiredDocs(type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationHome);

function runTestsFunc(setState) {
  return () => {
    setState({
      kit: false,
      selectType: false,
      docUpload: false,
      permitForm: false,
      shareKeys: false,
      runTest: true,
    });
  };
}

function shareKeysFunc(setState) {
  return (data) => {
    Storage.set("data", JSON.stringify(data));
    Storage.set("startIpSubmission", true);
    setState({
      kit: false,
      selectType: false,
      docUpload: false,
      permitForm: false,
      shareKeys: true,
      runTest: false,
    });
  };
}

function ipPermitFormFunc(setState) {
  return () => {
    Storage.set("docApproved", true);
    setState({
      kit: false,
      selectType: false,
      docUpload: false,
      permitForm: true,
      shareKeys: false,
      runTest: false,
    });
  };
}

function docUploadFunc(setState) {
  return (selection) => {
    Storage.set("select-type-single", true);
    Storage.set("selection-single", selection);
    Storage.set("upload-start-single", true);
    setState({
      kit: false,
      selectType: false,
      docUpload: true,
      permitForm: false,
      shareKeys: false,
      runTest: false,
    });
  };
}

function selectTypeFunc(setState) {
  return () => {
    Storage.set("kit-download-single", true);
    setState({
      kit: false,
      selectType: true,
      docUpload: false,
      permitForm: false,
      shareKeys: false,
      runTest: false,
    });
  };
}
